import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSidebarSimpleRightWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSidebarSimpleRightWide"><Path fillRule="evenodd" clipRule="evenodd" d="M22 4H2V20H22V4ZM15 5.5V18.5H3.5V5.5H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSidebarSimpleRightWide;
